// extracted by mini-css-extract-plugin
export var dropdown = "_uf-0";
export var imageWrapper = "_uf-3";
export var itemNameContainer = "_uf-1";
export var productImage = "_uf-2";
export var spinnerWrapper = "_uf-4";